import { fortuneDoubleColors } from '@/constants/fortune-double/colors';
import { FortuneDoubleCardProps } from './props';
import styles from './styles.module.scss';

export default function FortuneDoubleCard({ color }: FortuneDoubleCardProps) {
  const backgroundColor = fortuneDoubleColors.get(color);

  return (
    <div
      className={styles.container}
      style={{
        backgroundColor,
      }}
    />
  );
}
